<div
  *ngIf="isIOSApp"
  class="ios-safe-area-overflow ios-safe-area-top"
  [ngStyle]="{ 'top.px': 0, 'height.px': iosSafeAreaOverflowHeight }"
></div>
<router-outlet appDownload appNotificationSound></router-outlet>
<div
  *ngIf="isIOSApp && !isKeyboardOpen"
  class="ios-safe-area-overflow ios-safe-area-bottom"
  [ngStyle]="{ 'bottom.px': 0, 'height.px': iosSafeAreaBottomHeight }"
></div>

<app-loading-panel
  [showLoading]="loader"
  [hideText]="true"
  [isSmall]="true"
></app-loading-panel>

@if (isOrdersAiEnabled && storesAiSafeUrl && shouldShowAiWidget()) {
  <iframe
    [src]="storesAiSafeUrl"
    class="ai-widget-frame"
    [class.launcher]="aiWidgetLauncherState === 'launcher'"
    [class.chat]="aiWidgetLauncherState === 'chat'"
    allow="microphone"
    [hidden]="!isStoreCatalogPage()"
  >
  </iframe>
}

<ng-container #rootViewContainer></ng-container>
